function streamJobs(
) {
}
function consumeJob(
) {
  // PUT node.key+'/lock?ttl=10&prevExist=false'
}
